export const APP_FE_VERSION = '1.2.2.0';
